<template>
  <div class="md-layout md-alignment-center-center container gray-6 bg">
    <p v-if="error" class="error">
      {{
        error.message ||
          error.errorDescription ||
          "Unkown error when redirecting to payment portal"
      }}
    </p>
    <router-link v-if="error" :to="{name: 'profile'}">Back to account</router-link>
    <h3 v-if="loading">Redirecting to billing portal...</h3>
    <md-progress-spinner v-if="loading" md-mode="indeterminate" />
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style>
</style>